import type { Page_Links } from "~/core";

export const isPageLinks = (item: unknown): item is Page_Links => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "page_links"
  );
};
